import type { ReactElement } from 'react';
import { memo } from 'react';
import { getCardPresentation } from '@cards/cards';
import { AuthoredGlyph } from './AuthoredGlyph.js';

export interface CardGlyphProps {
  defId: string;
  size?: number;
}

/**
 * Tiny code-native pixel symbol: no external image assets or runtime drawing.
 * Memoised for the same reason as [AuthoredGlyph]: both props are primitives, so
 * a card's art is built once and skipped by every later render of its owner.
 */
export const CardGlyph = memo(function CardGlyph({ defId, size = 40 }: CardGlyphProps): ReactElement {
  const glyph = getCardPresentation(defId)?.glyph;
  return (
    <AuthoredGlyph
      glyph={glyph}
      testId={`card-glyph-${defId}`}
      visualId={defId}
      size={size}
    />
  );
});
